<template lang="pug"
src='./takeoff.pug'>
</template>

<script>
import Vue from 'vue'
import store from 'CommonApp/store'
import Information from './tabs-components/information.vue'
import MechanicalSystems from './tabs-components/mechanical-systems.vue'
import MechanicalSystemsAddition from './tabs-components/mechanical-systems-addition.vue'
import MechanicalSystemsRemodel from './tabs-components/mechanical-systems-remodel.vue'
import FloorsRoofs from './tabs-components/floors-roofs.vue'
import FloorsRoofsAddition from './tabs-components/floors-roofs-addition.vue'
import Walls from './tabs-components/walls-tab.vue'
import WallsAddition from './tabs-components/walls-tab-addition.vue'
import Glazing from './tabs-components/glazing.vue'
import GlazingInExisting from './tabs-components/glazing-in-existing.vue'
import Compliance from './tabs-components/compliance.vue'
import _ from 'lodash'
import imgRequest from '@/common/img/baseline-assignment-24px.svg'
import helpCLue from '@/common/img/question-clue.svg'
import linkIcon from '@/common/img/baseline-call_missed_outgoing-24px.svg'
import easyBtn from 'Common/components/easy-btn.vue'
import saveBtn from '@/common/components/saveBtn.vue'
import typeOfBuildingsHelp from '@/app/take-off-tool/tabs-components/pops/typeBuildings.vue'
import compliancePopUp from '@/app/take-off-tool/tabs-components/pops/compliancePopUp.vue'
import alteredRoofs from '@/app/take-off-tool/tabs-components/pops/alteredRoof.vue'
import vaultsCathedral from '@/app/take-off-tool/tabs-components/pops/vaultsCathedral.vue'
// import orientationDegrees from '@/app/take-off-tool/tabs-components/pops/orientationDegrees.vue'
import {EventBus} from '@/common/event-bus'
import savingImage from '@/common/img/Spinner-1s-200px.svg'
import {Person, PhoneNumber, EmailAddress, PostalAddress} from 'janux-people'
import readBuild from '../../util/readBuild'

export default {
	name: 'project-takeoff',
	props: ['id', 'tab'],
	components: {
		typeOfBuildingsHelp,
		compliancePopUp,
		alteredRoofs,
		vaultsCathedral,
		// orientationDegrees,
		easyBtn,
		saveBtn,
		Information,
		FloorsRoofs,
		FloorsRoofsAddition,
		MechanicalSystems,
		MechanicalSystemsAddition,
		MechanicalSystemsRemodel,
		Walls,
		WallsAddition,
		Glazing,
		GlazingInExisting,
		Compliance},
	data () {
		return {
			build: '',
			savingAnimation: savingImage,
			typeBuilding: false,
			compliancePopUp: false,
			svgImageFloorReference: [false, 'wichTypeOfFloor'],
			imagRequest: imgRequest,
			imgHelpClue: helpCLue,
			imgLinkIcon: linkIcon,
			popUp: false,
			headerTitle: 'Project Information',
			currentTab: 'tab-info',
			loaded: false,
			takeoffKey: 'takeoffKey',
			glazingLabel: 'Glazing',
			project: {},
			control: {},
			contacts: [],
			validContacts: {
				DM: {
					result: true
				},
				SG: {
					result: true
				}
			},
			projType: {},
			projTabStoreKey: 'projCurrTab',	// add project id on load
			totalConditionedAreas: {},
			time: 0
		}
	},
	beforeRouteEnter: (to, from, next) => {
		let project = {}

		Vue.e24.projectService.findOneById(to.params.id).then((projectLoaded) => {
			project = projectLoaded
			store.dispatch({
				type: 'updateActiveProject',
				value: project.projId
			})

			let formControlsToLoad = ['info', 'mech', 'walls', 'glazing', 'floor_attic', 'prefs']

			// In case of addition, add appropriate form control options
			if (!project.isNewHome) {
				formControlsToLoad.push('glazing_existing')
			}
			return Vue.e24.formService.findControlByForm(formControlsToLoad, project.takeoff)
		}).then((control) => {
			next((vm) => {
				console.log('Editing project', project)
				console.log('Loaded controls', control)

				// Project tab storage key
				vm.projTabStoreKey = `${vm.projTabStoreKey}-${project.projId}`

				// Loading project
				vm.project = project

				// Loading controls
				vm.control = control

				// Glazing title
				vm.glazingLabel = (project.isNewHome) ? 'Glazing' : 'Addition Glazing'

				// let localStorage = vm.getLocalStorage()
				vm.currentTab = (!_.isNil(to.params.tab) && to.params.tab !== '') ? to.params.tab : Vue.jnx.storageService.findItem(vm.projTabStoreKey, true)
				vm.currentTab = (Vue.jnx.storageService.findItem(vm.projTabStoreKey, true) === 'tab-glazing-in-existing' && (project.isNewHome)) ? 'tab-glazing' : vm.currentTab
				vm.currentTab = (Vue.jnx.storageService.findItem(vm.projTabStoreKey, true) === 'tab-glazing-in-existing') ? 'tab-glazing-in-existing' : vm.currentTab

				vm.currentTab = (!_.isNil(vm.currentTab)) ? vm.currentTab : 'tab-info'
				vm.setCurrentTabLocalStorage()

				vm.contacts = project.contacts
				vm.ensureProjectContacts()

				vm.loaded = true
				// console.debug(`beforeRouteEnter: current tab is ${vm.currentTab}`)
			})
		})
	},
	created: function () {
		this.projType = process.env.PROJTYPE
		EventBus.$on('open-type-building-popUp', this.openTypeBuildingPopUpListener)
		EventBus.$on('open-compliance-company-name-popUp', this.openComplianceCompanyNamePopUpListener)
		EventBus.$on('saving-info', this.savingInfoListener)
		this.getLocalStorage()

		EventBus.$on('createDecisionMakerContact', this.createDecisionMakerContactListener)
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	methods: {
		savingInfoListener () {
			// console.log('saving-info event')
			this.goNextOrPrevious('save')
		},
		openTypeBuildingPopUpListener (value) {
			this.popUp = true
			this.typeBuilding = value
		},
		openComplianceCompanyNamePopUpListener () {
			this.popUp = true
			this.compliancePopUp = true
		},
		createDecisionMakerContactListener () {
			this.setContact('Decision Maker', this.createEmptyContact('DM'))
		},
		canShow (screenName) {
			let canShow = false
			switch (this.project.takeoff) {
			case process.env.PROJTYPE.newBuilding:
			case process.env.PROJTYPE.detachedAdd:
				canShow = (_.indexOf(['floorsRoofs', 'mechSys', 'walls', 'glazing', 'compliance'], screenName) !== -1)
				break
			case process.env.PROJTYPE.ePlusAdd:
			case process.env.PROJTYPE.conversion:
				canShow = (_.indexOf(['floorsRoofsAdd', 'mechSysAdd', 'wallsAdd', 'glazing', 'glazingExist', 'compliance'], screenName) !== -1)
				break
			case process.env.PROJTYPE.remodel:
				canShow = (_.indexOf(['floorsRoofs', 'mechSysRem', 'wallsAdd', 'glazingExist', 'compliance'], screenName) !== -1)
				break
			}
			return canShow
		},
		additionConversion (screenName) {
			let additionConversion = false
			switch (this.project.takeoff) {
			case process.env.PROJTYPE.ePlusAdd:
				additionConversion = 'addition'
				break
			case process.env.PROJTYPE.conversion:
				additionConversion = 'conversion'
				break
			}
			return additionConversion
		},
		saveProject () {
			this.project.contacts = this.contacts
			if (
				this.project.floorsRoofs.totalEncGaraArea === '0' ||
				this.project.floorsRoofs.totalArea === '0'
			) {
				console.log('value is zero')
				this.resetGarageToZero()
			}
			return Vue.e24.projectService.update(this.project).then((proj) => {
				console.debug('project saved', proj)
				this.project = proj
				this.contacts = proj.contacts
				this.takeoffKey = new Date().getTime() // Can be anything
				return this.project
			})
		},
		resetGarageToZero () {
			let takeOff = this.project.takeoff
			// console.log('takeoff is ', takeOff)
			switch (takeOff) {
			case '4':
			case '6':
				this.project.walls.garageDoorArea.map((r, i) => {
					this.project.walls.garageDoorArea[i].value = '0'
				})
				this.project.walls.attachedGarage.values.map((r, i) => {
					this.project.walls.attachedGarage.values[i].length = '0'
				})
				break
			case '5':
			case '7':
			case '8':
				this.project.walls.perimeters.map((per, i) => {
					this.project.walls.perimeters[i].garage.values.map((values, x) => {
						this.project.walls.perimeters[i].garage.values[x].value = '0'

						this.project.walls.perimeters[i].garage.wall.map((wall, z) => {
							this.project.walls.perimeters[i].garage.wall[z].value = '0'
						})
					})
					this.project.walls.door.garage.map((garage, j) => {
						this.project.walls.door.garage[j].value = '0'
					})
				})
				break
			}
		},
		onTakeOffTabChange (tabId) {
			this.currentTab = tabId
			// console.debug(`onTakeOffTabChange: currentTab is ${this.currentTab}`)

			console.debug('Takeoff tab change', tabId, event)
			console.debug('tabid is ', tabId)
			// Save project on tab change
			this.saveProject().then((savedPrj) => {
				console.debug('Saved project', savedPrj)
			})
			// save currentTab in local Storage
			this.setCurrentTabLocalStorage()
			// this.getLocalStorage()
		},
		printHeader () {
			this.headerTitle = this.project.name
		},
		requestReport () {
			// Save project first
			this.saveProject().then((result) => {
				// go to audit
				if (!_.isNil(result)) {
					this.$router.push({name: 'project.audit', params: {id: this.project.projId}})
				}
			})
		},
		goNextOrPrevious (goOrBack) {
			// 1.- Get current value of tab
			let tabNow = this.currentTab
			// 2.- know wich is the index of that value

			let newHomeTabIndex = [ {tab: 'tab-info'}, {tab: 'tab-floors'}, {tab: 'tab-mechsystems'}, {tab: 'tab-walls'}, {tab: 'tab-glazing'}, {tab: 'tab-compliance'} ]

			let additionTabIndex = [ {tab: 'tab-info'}, {tab: 'tab-floors'}, {tab: 'tab-mechsystems'}, {tab: 'tab-walls'}, {tab: 'tab-glazing-in-existing'}, {tab: 'tab-glazing'}, {tab: 'tab-compliance'} ]

			let remodelTabIndex = [ {tab: 'tab-info'}, {tab: 'tab-floors'}, {tab: 'tab-mechsystems'}, {tab: 'tab-walls'}, {tab: 'tab-glazing-in-existing'}, {tab: 'tab-compliance'} ]

			let conversionTabIndex = [ {tab: 'tab-info'}, {tab: 'tab-floors'}, {tab: 'tab-mechsystems'}, {tab: 'tab-walls'}, {tab: 'tab-glazing-in-existing'}, {tab: 'tab-glazing'}, {tab: 'tab-compliance'} ]

			let currentIndexPlus, res

			switch (this.project.takeoff) {
			case '4':
				currentIndexPlus = _.findIndex(newHomeTabIndex, {tab: tabNow})
				break

			case '5':
				currentIndexPlus = _.findIndex(additionTabIndex, {tab: tabNow})
				break
			case '6':
				currentIndexPlus = _.findIndex(newHomeTabIndex, {tab: tabNow})
				break

			case '7':
				currentIndexPlus = _.findIndex(conversionTabIndex, {tab: tabNow})
				break

			case '8':
				currentIndexPlus = _.findIndex(remodelTabIndex, {tab: tabNow})
				break

			default:
				break
			}

			if (goOrBack === 'go') {
				// console.log('project takeoff', this.project.takeoff)
				// 3.- plus 1 to that value
				currentIndexPlus++
				this.saveProject()
				// console.debug(`AllTabValues ${res}`)
			} else if (goOrBack === 'back') {
				currentIndexPlus--
				this.saveProject()
			} else if (goOrBack === 'save') {
				this.saveProject()
			}
			// console.log('res ', res.tab)
			switch (this.project.takeoff) {
			case '4':
			case '6':
				res = newHomeTabIndex[currentIndexPlus]
				break
			case '5':
				res = additionTabIndex[currentIndexPlus]
				break
			case '7':
				res = conversionTabIndex[currentIndexPlus]
				break
			case '8':
				res = remodelTabIndex[currentIndexPlus]
				break
			default:
				break
			}
			this.currentTab = res.tab
			// 5.- save currentTab in localStorage
			this.setCurrentTabLocalStorage()
			// this.getLocalStorage()
		},
		setCurrentTabLocalStorage () {
			// let localStorage = new LocalStorageService()
			Vue.jnx.storageService.setItem(this.projTabStoreKey, this.currentTab, true)
		},
		getLocalStorage () {
			// let localStorage = new LocalStorageService()
			// console.debug(`localStorage2 is ${localStorage.findItem('currentTab', true)}`)
			this.currentTab = (!Vue.jnx.storageService.findItem(this.projTabStoreKey, true)) ? 'tab-info' : Vue.jnx.storageService.findItem(this.projTabStoreKey, true)
			this.setCurrentTabLocalStorage()
			// console.debug(`getLocalStorage: currentTab is ${this.currentTab}`)
		},
		hideModal () {
			// this.$refs.contextualHelp.hide()
			this.popUp = false
			this.typeBuilding = false
			this.svgImageFloorReference[0] = false
			this.compliancePopUp = false
		},
		ensureProjectContacts () {
			// Check if project contains SG and DM (if apply) contacts
			const sg = _.find(this.contacts, (contact) => { return (contact.object.typeId === 'SG') })

			if (!sg) {
				this.setContact('Report Signer', this.createEmptyContact('SG'))
				console.debug('Report signer contact not found, crete new')
			}

			// Add DM?
			if (!this.project.sgnrIsDcsnMkr) {
				const dm = _.find(this.contacts, (contact) => { return (contact.object.typeId === 'SG') })
				if (!dm) {
					this.setContact('Decision Maker', this.createEmptyContact('DM'))
					console.debug('Decision maker contact not found, crete new')
				}
				this.enableDM = true
			}
		},
		setContact (title, object) {
			if (!_.find(this.contacts, (contact) => {
				return (contact.object.typeId === object.typeId)
			})) {
				this.contacts.push({title, object})
			}
		},
		createEmptyContact (typeId) {
			let emptyContactObj = new Person('', '', '', '', '', '')
			emptyContactObj.setContactMethod('WORK', new PhoneNumber())
			// emptyContactObj.setContactMethod('MOBILE', new PhoneNumber())
			emptyContactObj.setContactMethod('WORK', new EmailAddress())
			emptyContactObj.setContactMethod('WORK', new PostalAddress())
			emptyContactObj.typeId = typeId
			emptyContactObj.projId = this.project.projId
			emptyContactObj.userId = Vue.e24.security.currentUser.userId
			return emptyContactObj
		}
	},
	beforeDestroy () {
		// E24-36: unregister all listeners subscribed in created() --
		// only 'saving-info' was unsubscribed here before, leaking the
		// other three on every remount.
		EventBus.$off('open-type-building-popUp', this.openTypeBuildingPopUpListener)
		EventBus.$off('open-compliance-company-name-popUp', this.openComplianceCompanyNamePopUpListener)
		EventBus.$off('saving-info', this.savingInfoListener)
		EventBus.$off('createDecisionMakerContact', this.createDecisionMakerContactListener)
	}
}
</script>



// WEBPACK FOOTER //
// src/app/take-off-tool/takeoff.vue